import PropTypes from 'prop-types';
import { useContext, useMemo } from 'react';

import { DELETE_DEVICE_REMOVE_DEVICE } from 'src/common/constants/localizations/devices';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import debounce from '../../../utils/debounce';

import css from './device.module.scss';

const Device = ({ dataTestId, device, onDeleteDevice }) => {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);

  const handleDeleteDevice = useMemo(
    () => debounce(() => onDeleteDevice(device)),
    [device, onDeleteDevice],
  );

  return (
    <div data-testid={dataTestId} className={css.device}>
      <div className={css.deviceInfo}>
        <p className={css.deviceName} data-testid="deviceName">
          {device.displayName}
        </p>
        <p className={css.deviceSerial} data-testid="deviceSerial">
          {device.serial}
        </p>
      </div>
      <button
        data-testid="deleteButton"
        className={css.deleteButton}
        onClick={handleDeleteDevice}
        tabIndex="0"
      >
        <span data-testid="deleteButtonSRText" className={css.srOnly}>
          {getLocalizedText(DELETE_DEVICE_REMOVE_DEVICE)}
        </span>
      </button>
    </div>
  );
};

Device.propTypes = {
  dataTestId: PropTypes.string.isRequired,
  device: PropTypes.shape({
    id: PropTypes.number.isRequired,
    displayName: PropTypes.string.isRequired,
    serial: PropTypes.string.isRequired,
  }).isRequired,
  onDeleteDevice: PropTypes.func.isRequired,
};

export default Device;
